import React from "react";
import {
  FileText,
  User,
  Wallet,
  Building2,
  Users,
  Briefcase,
  CheckCircle2
} from "lucide-react";

import "../Styles/Appendix.css";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import logo from "../assets/rcslogo.png";



export default function Appendix() {


const reviewRef = React.useRef(null);


  const [currentStep, setCurrentStep] =
        React.useState(1);

  const steps = [

    {
      id: 1,
      title: "Personal",
      icon: User
    },

    {
      id: 2,
      title: "Loan",
      icon: Wallet
    },

    {
      id: 3,
      title: "Financial",
      icon: Building2
    },

    {
      id: 4,
      title: "References",
      icon: Users
    },

        {
        id: 5,
        title: "Details",
        icon: Briefcase
        },

    {
      id: 6,
      title: "Review",
      icon: CheckCircle2
    }

  ];

  const [formData, setFormData] =
React.useState({

    //KYC

  fullName: "",

  dateOfBirth: "",

  gender: "",

  address: "",

  village: "",

  region: "",

  phone: "",

  secondaryPhone: "",

  email: "",

  idType: "",

  idNumber: "",

  tinNumber: "",

  occupation: "",

  employer: "",

  monthlyIncome: "",

  yearsEmployed: "",


  loanType: "",

loanPurpose: "",

loanAmount: "",

repaymentPeriod: "",

interestRate: "",

desiredMonthlyPayment: "",

collateralType: "",

collateralValue: "",

existingLoans: "",

existingLoanBalance: "",

//Balancesheet
bankName: "",

accountNumber: "",

accountType: "",

otherIncome: "",

monthlyExpenses: "",

monthlyRent: "",

savingsAmount: "",

creditCards: "",

creditCardBalance: "",

existingDebt: "",

assetsValue: "",

liabilitiesValue: "",

//references
reference1Name: "",
reference1Address: "",
reference1Phone: "",
reference1Relationship: "",
reference1YearsKnown: "",

reference2Name: "",
reference2Address: "",
reference2Phone: "",
reference2Relationship: "",
reference2YearsKnown: "",

guarantorName: "",
guarantorAddress: "",
guarantorPhone: "",
guarantorOccupation: "",
guarantorEmployer: "",
guarantorMonthlyIncome: "",
guarantorIdNumber: "",

//Business Details
businessName: "",

businessRegistrationNumber: "",

businessAddress: "",

businessPhone: "",

businessEmail: "",

businessYearsOperation: "",

businessEmployees: "",

businessProposal: "",

businessPurpose: "",

businessPlan: "",

breakEvenPeriod: "",

monthlySales: "",

monthlyExpensesBusiness: "",

grossProfit: "",

netProfit: "",

projectedRevenue: "",

projectedGrowth: "",

competitors: "",

targetMarket: "",

marketingStrategy: "",

//agriculture

agricultureType: "",
farmName: "",
farmLocation: "",
farmSize: "",
landOwnership: "",
harvestCycle: "",
expectedHarvestDate: "",
expectedYield: "",
expectedRevenue: "",
expectedExpenses: "",
expectedNetProfit: "",
agriculturePurpose: "",
farmingExperience: "",
farmAssets: "",
buyerInformation: "",

//Vehicle
vehicleType: "",
vehicleMake: "",
vehicleModel: "",
vehicleYear: "",
vehicleColor: "",
vehicleMileage: "",
sellerName: "",
sellerPhone: "",
purchasePrice: "",
vehicleUsage: "",
vehicleIncome: "",
insuranceProvider: "",

//Education
institutionName: "",
country: "",
programmeName: "",
programmeDuration: "",
tuitionCost: "",
accommodationCost: "",
travelCost: "",
booksCost: "",
graduationDate: "",
scholarshipAmount: "",

//Home Improvement
propertyAddress: "",
ownershipStatus: "",
improvementType: "",
contractorName: "",
estimatedProjectCost: "",
completionDate: "",
propertyValueBefore: "",
propertyValueAfter: "",

//Personal
personalLoanReason: "",
expectedBenefit: "",
repaymentStrategy: "",
otherFundingSources: "",
disposableIncome: "",
});


const handleChange = (e) => {

  setFormData({

    ...formData,

    [e.target.name]:
      e.target.value

  });

};

const nextStep = () => {

  if (currentStep < 6) {

    setCurrentStep(
      currentStep + 1
    );

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

  }

};

const previousStep = () => {

  if (currentStep > 1) {

    setCurrentStep(
      currentStep - 1
    );

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

  }

};


const addSectionTitle = (
  pdf,
  title,
  y
) => {

  pdf.setFillColor(
    ...COLORS.gold
  );

  pdf.roundedRect(
    15,
    y - 6,
    180,
    10,
    2,
    2,
    "F"
  );

  pdf.setTextColor(
    255,
    255,
    255
  );

  pdf.setFont(
    "helvetica",
    "bold"
  );

  pdf.setFontSize(12);

  pdf.text(
    title,
    20,
    y
  );

  pdf.setTextColor(
    50,
    50,
    50
  );

  return y + 15;

};


const addField = (
  pdf,
  label,
  value,
  y
) => {

  pdf.setFillColor(
    248,
    248,
    248
  );

  pdf.roundedRect(
    15,
    y - 5,
    180,
    12,
    2,
    2,
    "F"
  );

  pdf.setTextColor(
    80,
    80,
    80
  );

  pdf.setFont(
    "helvetica",
    "bold"
  );

  pdf.text(
    label,
    20,
    y
  );

  pdf.setFont(
    "helvetica",
    "normal"
  );

  pdf.text(
    String(value || ""),
    90,
    y
  );

  return y + 15;

};

const COLORS = {

  navy: [15, 43, 76],

  gold: [212, 175, 55],

  light: [245, 247, 250],

  text: [50, 50, 50]

};




const addHeader = (
  pdf,
  title = "Loan Application Package"
) => {

  pdf.setFillColor(
    ...COLORS.navy
  );

  pdf.rect(
    0,
    0,
    210,
    18,
    "F"
  );

  pdf.setTextColor(
    255,
    255,
    255
  );

  pdf.setFont(
    "helvetica",
    "bold"
  );

  pdf.setFontSize(15);

  pdf.text(
    "RCS FINANCE",
    15,
    12
  );

  pdf.setFontSize(9);

  pdf.text(
    title,
    150,
    12
  );

};


const addFooter = (
  pdf,
  page,
  totalPages
) => {

  pdf.setDrawColor(
    ...COLORS.gold
  );

  pdf.line(
    15,
    285,
    195,
    285
  );

  pdf.setTextColor(
    100,
    100,
    100
  );

  pdf.setFontSize(8);

  pdf.text(
    `Page ${page} of ${totalPages}`,
    165,
    290
  );

  pdf.text(
    "RCS Finance Confidential",
    15,
    290
  );

};



const generatePdf = async () => {

  const pdf =
    new jsPDF(
      "p",
      "mm",
      "a4"
    );

  const pageWidth =
    pdf.internal.pageSize.getWidth();

  let y = 20;


pdf.setFillColor(
  ...COLORS.navy
);

pdf.rect(
  0,
  0,
  210,
  297,
  "F"
);
/* =====================
   COVER PAGE
===================== */

// White background
pdf.setFillColor(
  255,
  255,
  255
);

pdf.rect(
  0,
  0,
  210,
  297,
  "F"
);

try {

  const img = new Image();

  img.src = logo;

  await new Promise(
    resolve => {
      img.onload = resolve;
    }
  );

  pdf.addImage(
    img,
    "PNG",
    pageWidth / 2 - 35,
    40,
    70,
    70
  );

} catch (err) {

  console.log(err);

}

pdf.setTextColor(
  40,
  40,
  40
);

pdf.setFont(
  "helvetica",
  "bold"
);

pdf.setFontSize(24);

pdf.text(
  "LOAN APPLICATION PACKAGE",
  pageWidth / 2,
  135,
  {
    align: "center"
  }
);

pdf.setFont(
  "helvetica",
  "normal"
);

pdf.setFontSize(12);

pdf.text(
  `Applicant: ${formData.fullName || ""}`,
  pageWidth / 2,
  155,
  {
    align: "center"
  }
);

pdf.text(
  `Generated: ${new Date().toLocaleDateString()}`,
  pageWidth / 2,
  165,
  {
    align: "center"
  }
);

pdf.setDrawColor(
  ...COLORS.gold
);

pdf.setLineWidth(1);

pdf.line(
  60,
  180,
  150,
  180
);

  /* =====================
     PAGE 2
  ===================== */

  pdf.addPage();
addHeader(pdf);
y = 30;


pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);



  y =
    addSectionTitle(
      pdf,
      "Personal Information",
      y
    );

  pdf.setFontSize(11);
const personalFields = [

  ["Full Name", formData.fullName],
  ["Date Of Birth", formData.dateOfBirth],
  ["Gender", formData.gender],

  ["Phone", formData.phone],
  ["Secondary Phone", formData.secondaryPhone],
  ["Email", formData.email],

  ["Address", formData.address],
  ["Village / Town", formData.village],
  ["Region", formData.region],

  ["ID Type", formData.idType],
  ["ID Number", formData.idNumber],
  ["TIN Number", formData.tinNumber],

  ["Occupation", formData.occupation],
  ["Employer", formData.employer],
  ["Years Employed", formData.yearsEmployed],

  ["Monthly Income", formData.monthlyIncome]

];

personalFields.forEach(
 ([label,value]) => {

   y = addField(
     pdf,
     label,
     value,
     y
   );

 });

  /* =====================
     LOAN PAGE
  ===================== */

  pdf.addPage();
addHeader(pdf);
y = 30;


pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);




  y =
    addSectionTitle(
      pdf,
      "Loan Information",
      y
    );

[
  ["Loan Type", formData.loanType],
  ["Loan Amount", formData.loanAmount],
  ["Repayment Period", formData.repaymentPeriod],
  ["Interest Rate", formData.interestRate + "%"],
  ["Desired Monthly Payment", formData.desiredMonthlyPayment],

  ["Collateral Type", formData.collateralType],
  ["Collateral Value", formData.collateralValue],

  ["Existing Loans", formData.existingLoans],
  ["Existing Loan Balance", formData.existingLoanBalance]
].forEach(
    ([label, value]) => {

y = addField(
  pdf,
  label,
  value,
  y
);

    }
  );

  y += 10;

  pdf.text(
    "Purpose Of Loan:",
    20,
    y
  );

  y += 8;

  const purposeLines =
    pdf.splitTextToSize(
      formData.loanPurpose || "",
      170
    );

  pdf.text(
    purposeLines,
    20,
    y
  );

  /* =====================
     FINANCIAL PAGE
  ===================== */

  pdf.addPage();
addHeader(pdf);
y = 30;



pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);



  y =
    addSectionTitle(
      pdf,
      "Financial Information",
      y
    );

[
  ["Bank Name", formData.bankName],
  ["Account Number", formData.accountNumber],
  ["Account Type", formData.accountType],

  ["Other Income", formData.otherIncome],
  ["Monthly Expenses", formData.monthlyExpenses],
  ["Monthly Rent/Mortgage", formData.monthlyRent],

  ["Savings Amount", formData.savingsAmount],

  ["Credit Cards", formData.creditCards],
  ["Credit Card Balance", formData.creditCardBalance],

  ["Existing Debt", formData.existingDebt],
  ["Assets Value", formData.assetsValue],
  ["Liabilities Value", formData.liabilitiesValue]
].forEach(
    ([label, value]) => {

y = addField(
  pdf,
  label,
  value,
  y
);

    }
  );

  /* =====================
     REFERENCES PAGE
  ===================== */

  pdf.addPage();
addHeader(pdf);
y = 30;


pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);




  y =
    addSectionTitle(
      pdf,
      "References & Guarantor",
      y
    );

  pdf.text(
    `Reference 1: ${formData.reference1Name}`,
    20,
    y
  );

  y += 8;

  pdf.text(
    `Reference 2: ${formData.reference2Name}`,
    20,
    y
  );

  y += 8;

  pdf.text(
    `Guarantor: ${formData.guarantorName}`,
    20,
    y
  );


pdf.addPage();
addHeader(pdf);
y = 30;


pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);





y = addSectionTitle(
  pdf,
  "Reference Information",
  y
);

pdf.setFontSize(11);

/* REFERENCE 1 */

pdf.text(
  "Reference #1",
  20,
  y
);

y += 10;

[
  ["Name", formData.reference1Name],
  ["Phone", formData.reference1Phone],
  ["Relationship", formData.reference1Relationship],
  ["Years Known", formData.reference1YearsKnown],
  ["Address", formData.reference1Address]
].forEach(([label, value]) => {

  y = addField(
    pdf,
    label,
    value,
    y
  );

});

/* REFERENCE 2 */

y += 10;

pdf.text(
  "Reference #2",
  20,
  y
);

y += 10;

[
  ["Name", formData.reference2Name],
  ["Phone", formData.reference2Phone],
  ["Relationship", formData.reference2Relationship],
  ["Years Known", formData.reference2YearsKnown],
  ["Address", formData.reference2Address]
].forEach(([label, value]) => {

y = addField(
  pdf,
  label,
  value,
  y
);

});

pdf.addPage();
addHeader(pdf);
y = 30;



pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);




y = addSectionTitle(
  pdf,
  "Guarantor Information",
  y
);

[
  ["Name", formData.guarantorName],
  ["Phone", formData.guarantorPhone],
  ["Address", formData.guarantorAddress],
  ["Occupation", formData.guarantorOccupation],
  ["Employer", formData.guarantorEmployer],
  ["Monthly Income", formData.guarantorMonthlyIncome],
  ["ID Number", formData.guarantorIdNumber]
].forEach(([label, value]) => {

y = addField(
  pdf,
  label,
  value,
  y
);

});
  /* =====================
     LOAN TYPE PAGE
  ===================== */

  pdf.addPage();
addHeader(pdf);
y = 30;



pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);



  y =
    addSectionTitle(
      pdf,
      `${formData.loanType} Details`,
      y
    );

if (
  formData.loanType ===
  "Business"
) {

  pdf.addPage();
addHeader(pdf);
y = 30;


pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);




  y = addSectionTitle(
    pdf,
    "Business Profile",
    y
  );

  [
    ["Business Name", formData.businessName],
    ["Registration Number", formData.businessRegistrationNumber],
    ["Address", formData.businessAddress],
    ["Phone", formData.businessPhone],
    ["Email", formData.businessEmail],
    ["Years Operating", formData.businessYearsOperation],
    ["Employees", formData.businessEmployees]
  ].forEach(([label,value]) => {

y = addField(
  pdf,
  label,
  value,
  y
);

  });

  pdf.addPage();
addHeader(pdf);
y = 30;


pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);



  y = addSectionTitle(
    pdf,
    "Business Financial Analysis",
    y
  );

[
  ["Monthly Sales", formData.monthlySales],
  ["Monthly Expenses", formData.monthlyExpensesBusiness],
  ["Gross Profit", formData.grossProfit],
  ["Net Profit", formData.netProfit],
  ["Projected Revenue", formData.projectedRevenue],
  ["Projected Growth", formData.projectedGrowth]
].forEach(([label,value]) => {

  y = addField(
    pdf,
    label,
    value,
    y
  );

});

y += 10;

y = addField(
  pdf,
  "Business Proposal",
  "",
  y
);

pdf.text(
  pdf.splitTextToSize(
    formData.businessProposal || "",
    170
  ),
  20,
  y + 5
);



pdf.addPage();
addHeader(pdf);
y = 30;


pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);




y = addSectionTitle(
  pdf,
  "Agriculture Information",
  y
);

[
  ["Farm Name", formData.farmName],
  ["Farm Location", formData.farmLocation],
  ["Farm Size", formData.farmSize],
  ["Land Ownership", formData.landOwnership],
  ["Agriculture Type", formData.agricultureType],
  ["Experience", formData.farmingExperience],
  ["Harvest Cycle", formData.harvestCycle],
  ["Expected Harvest", formData.expectedHarvestDate],
  ["Expected Yield", formData.expectedYield],
  ["Expected Revenue", formData.expectedRevenue],
  ["Expected Expenses", formData.expectedExpenses],
  ["Expected Net Profit", formData.expectedNetProfit]
].forEach(([label,value]) => {

y = addField(
  pdf,
  label,
  value,
  y
);

});

y += 10;

pdf.text(
  "Purpose Of Financing:",
  20,
  y
);

y += 8;

pdf.text(
  pdf.splitTextToSize(
    formData.agriculturePurpose || "",
    170
  ),
  20,
  y
);
}
pdf.addPage();
addHeader(pdf);
y = 30;



pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);



y = addSectionTitle(
  pdf,
  "Vehicle Loan Information",
  y
);

[
  ["Vehicle Type", formData.vehicleType],
  ["Make", formData.vehicleMake],
  ["Model", formData.vehicleModel],
  ["Year", formData.vehicleYear],
  ["Colour", formData.vehicleColor],
  ["Mileage", formData.vehicleMileage],
  ["Seller", formData.sellerName],
  ["Seller Phone", formData.sellerPhone],
  ["Purchase Price", formData.purchasePrice],
  ["Usage", formData.vehicleUsage],
  ["Monthly Income", formData.vehicleIncome],
  ["Insurance", formData.insuranceProvider]
].forEach(([label,value]) => {

y = addField(
  pdf,
  label,
  value,
  y
);
});

if (
  formData.loanType === "Education"
) {

  pdf.addPage();
  addHeader(pdf);

  y = 30;

  y = addSectionTitle(
    pdf,
    "Education Information",
    y
  );

  [
    ["Institution", formData.institutionName],
    ["Country", formData.country],
    ["Programme", formData.programmeName],
    ["Duration", formData.programmeDuration],
    ["Tuition", formData.tuitionCost],
    ["Accommodation", formData.accommodationCost],
    ["Travel", formData.travelCost],
    ["Books", formData.booksCost],
    ["Scholarship", formData.scholarshipAmount],
    ["Graduation", formData.graduationDate]
  ].forEach(([label,value]) => {

    y = addField(
      pdf,
      label,
      value,
      y
    );

  });

}
  /* =====================
     DECLARATION PAGE
  ===================== */

  pdf.addPage();
addHeader(pdf);
  y = 30;



pdf.setTextColor(
  240,
  240,
  240
);

pdf.setFontSize(50);

pdf.text(
  "RCS",
  40,
  180,
  {
    angle: 45
  }
);

pdf.setTextColor(
  50,
  50,
  50
);


  pdf.setFontSize(14);

  pdf.text(
    "Applicant Declaration",
    20,
    y
  );

  y += 15;

  pdf.setFontSize(11);

  const declaration =

    "I certify that the information provided in this application is true and correct to the best of my knowledge and I authorize RCS Finance to verify any information contained herein.";

  const declarationLines =
    pdf.splitTextToSize(
      declaration,
      170
    );

  pdf.text(
    declarationLines,
    20,
    y
  );

  y += 60;

  pdf.text(
    "______________________",
    20,
    y
  );

  pdf.text(
    "Applicant Signature",
    20,
    y + 8
  );

  pdf.text(
    "______________________",
    120,
    y
  );

  pdf.text(
    "Loan Officer",
    120,
    y + 8
  );


const pages =
  pdf.getNumberOfPages();

for (
 let i = 1;
 i <= pages;
 i++
) {

  pdf.setPage(i);

  addFooter(
    pdf,
    i,
    pages
  );


}


  pdf.save(
    `LoanApplication-${formData.fullName}.pdf`
  );

};



  return (

    <div className="appendix-page">

      {/* HERO */}

      <div className="appendix-hero">

        <div className="appendix-tag">

          <FileText size={14} />

          RCS FINANCE

        </div>

        <h1>
          Loan Application Wizard
        </h1>

        <p>
          Complete a professional
          loan application and
          export it as PDF.
        </p>

      </div>

      {/* STEP BAR */}

      <div className="wizard-steps">

{steps.map((step) => {

          const Icon = step.icon;

          return (

            <div
              key={step.id}
              className={
                step.id === currentStep
                  ? "wizard-step active"
                  : "wizard-step"
              }
            >

              <div className="wizard-icon">

                <Icon size={18} />

              </div>

              <span>
                {step.title}
              </span>

            </div>

          );

        })}

      </div>

      {/* CONTENT CARD */}
{currentStep === 1 && (
  <div className="wizard-card">

  <div className="wizard-card-header">

    <h2>
      Personal Information
    </h2>

    <p>
      Step 1 of 6
    </p>

  </div>

  <div className="wizard-form-grid">

    <div>

      <label>
        Full Name
      </label>

      <input
        type="text"
        name="fullName"
        value={formData.fullName}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Date Of Birth
      </label>

      <input
        type="date"
        name="dateOfBirth"
        value={formData.dateOfBirth}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Gender
      </label>

      <select
        name="gender"
        value={formData.gender}
        onChange={handleChange}
      >

        <option value="">
          Select
        </option>

        <option>
          Male
        </option>

        <option>
          Female
        </option>

      </select>

    </div>

    <div>

      <label>
        Phone Number
      </label>

      <input
        type="text"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Secondary Phone
      </label>

      <input
        type="text"
        name="secondaryPhone"
        value={formData.secondaryPhone}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Email Address
      </label>

      <input
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
      />

    </div>

    <div className="full-width">

      <label>
        Address
      </label>

      <input
        type="text"
        name="address"
        value={formData.address}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Village / Town
      </label>

      <input
        type="text"
        name="village"
        value={formData.village}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Region
      </label>

      <input
        type="text"
        name="region"
        value={formData.region}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        ID Type
      </label>

      <select
        name="idType"
        value={formData.idType}
        onChange={handleChange}
      >

        <option value="">
          Select
        </option>

        <option>
          National ID
        </option>

        <option>
          Passport
        </option>

        <option>
          Driver Licence
        </option>

      </select>

    </div>

    <div>

      <label>
        ID Number
      </label>

      <input
        type="text"
        name="idNumber"
        value={formData.idNumber}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        TIN Number
      </label>

      <input
        type="text"
        name="tinNumber"
        value={formData.tinNumber}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Occupation
      </label>

      <input
        type="text"
        name="occupation"
        value={formData.occupation}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Employer
      </label>

      <input
        type="text"
        name="employer"
        value={formData.employer}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Monthly Income
      </label>

      <input
        type="number"
        name="monthlyIncome"
        value={formData.monthlyIncome}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Years Employed
      </label>

      <input
        type="number"
        name="yearsEmployed"
        value={formData.yearsEmployed}
        onChange={handleChange}
      />

    </div>

  </div>

  <div className="wizard-actions">

<button
  className="wizard-next-btn"
  onClick={nextStep}
>
  Continue
</button>

  </div>

</div>
)}


{currentStep === 2 && (

<div className="wizard-card">

  <div className="wizard-card-header">

    <h2>
      Loan Information
    </h2>

    <p>
      Step 2 of 6
    </p>

  </div>

  <div className="wizard-form-grid">

    <div>

      <label>
        Loan Type
      </label>

      <select
        name="loanType"
        value={formData.loanType}
        onChange={handleChange}
      >

        <option value="">
          Select
        </option>

        <option>
          Personal
        </option>

        <option>
          Business
        </option>

        <option>
          Agriculture
        </option>

        <option>
          Vehicle
        </option>

        <option>
          Education
        </option>

        <option>
          Home Improvement
        </option>

      </select>

    </div>

    <div>

      <label>
        Loan Amount
      </label>

      <input
        type="number"
        name="loanAmount"
        value={formData.loanAmount}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Repayment Period
      </label>

      <select
        name="repaymentPeriod"
        value={formData.repaymentPeriod}
        onChange={handleChange}
      >

        <option value="">
          Select
        </option>

        <option>
          6 Months
        </option>

        <option>
          12 Months
        </option>

        <option>
          24 Months
        </option>

        <option>
          36 Months
        </option>

        <option>
          48 Months
        </option>

        <option>
          60 Months
        </option>

      </select>

    </div>

    <div>

      <label>
        Interest Rate %
      </label>

      <input
        type="number"
        name="interestRate"
        value={formData.interestRate}
        onChange={handleChange}
      />

    </div>

    <div className="full-width">

      <label>
        Purpose Of Loan
      </label>

      <textarea
        name="loanPurpose"
        value={formData.loanPurpose}
        onChange={handleChange}
        rows="4"
      />

    </div>

    <div>

      <label>
        Desired Monthly Payment
      </label>

      <input
        type="number"
        name="desiredMonthlyPayment"
        value={formData.desiredMonthlyPayment}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Collateral Type
      </label>

      <input
        type="text"
        name="collateralType"
        value={formData.collateralType}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Estimated Collateral Value
      </label>

      <input
        type="number"
        name="collateralValue"
        value={formData.collateralValue}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Existing Loans
      </label>

      <select
        name="existingLoans"
        value={formData.existingLoans}
        onChange={handleChange}
      >

        <option value="">
          Select
        </option>

        <option>
          Yes
        </option>

        <option>
          No
        </option>

      </select>

    </div>

    <div>

      <label>
        Existing Loan Balance
      </label>

      <input
        type="number"
        name="existingLoanBalance"
        value={formData.existingLoanBalance}
        onChange={handleChange}
      />

    </div>

  </div>

  <div className="wizard-actions">

    <button
      className="wizard-back-btn"
      onClick={previousStep}
    >
      Back
    </button>

<button
  className="wizard-next-btn"
  onClick={nextStep}
>
  Continue
</button>

  </div>

</div>

)}

{currentStep === 3 && (

<div className="wizard-card">

  <div className="wizard-card-header">

    <h2>
      Financial Information
    </h2>

    <p>
      Step 3 of 6
    </p>

  </div>

  <div className="wizard-form-grid">

    <div>

      <label>
        Bank Name
      </label>

      <input
        type="text"
        name="bankName"
        value={formData.bankName}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Account Number
      </label>

      <input
        type="text"
        name="accountNumber"
        value={formData.accountNumber}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Account Type
      </label>

      <select
        name="accountType"
        value={formData.accountType}
        onChange={handleChange}
      >

        <option value="">
          Select
        </option>

        <option>
          Savings
        </option>

        <option>
          Current
        </option>

      </select>

    </div>

    <div>

      <label>
        Other Monthly Income
      </label>

      <input
        type="number"
        name="otherIncome"
        value={formData.otherIncome}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Monthly Expenses
      </label>

      <input
        type="number"
        name="monthlyExpenses"
        value={formData.monthlyExpenses}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Rent / Mortgage
      </label>

      <input
        type="number"
        name="monthlyRent"
        value={formData.monthlyRent}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Savings Available
      </label>

      <input
        type="number"
        name="savingsAmount"
        value={formData.savingsAmount}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Credit Cards
      </label>

      <select
        name="creditCards"
        value={formData.creditCards}
        onChange={handleChange}
      >

        <option value="">
          Select
        </option>

        <option>
          Yes
        </option>

        <option>
          No
        </option>

      </select>

    </div>

    <div>

      <label>
        Credit Card Balance
      </label>

      <input
        type="number"
        name="creditCardBalance"
        value={formData.creditCardBalance}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Existing Debt
      </label>

      <input
        type="number"
        name="existingDebt"
        value={formData.existingDebt}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Total Assets Value
      </label>

      <input
        type="number"
        name="assetsValue"
        value={formData.assetsValue}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Total Liabilities
      </label>

      <input
        type="number"
        name="liabilitiesValue"
        value={formData.liabilitiesValue}
        onChange={handleChange}
      />

    </div>

  </div>

  <div className="wizard-actions">

    <button
      className="wizard-back-btn"
      onClick={previousStep}
    >
      Back
    </button>

    <button
      className="wizard-next-btn"
      onClick={nextStep}
    >
      Continue
    </button>

  </div>

</div>

)}

{currentStep === 4 && (

<div className="wizard-card">

  <div className="wizard-card-header">

    <h2>
      References & Guarantor
    </h2>

    <p>
      Step 4 of 6
    </p>

  </div>

  {/* REFERENCE 1 */}

  <div className="wizard-section-title">

    Reference #1

  </div>

  <div className="wizard-form-grid">

    <div>

      <label>
        Full Name
      </label>

      <input
        type="text"
        name="reference1Name"
        value={formData.reference1Name}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Phone Number
      </label>

      <input
        type="text"
        name="reference1Phone"
        value={formData.reference1Phone}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Relationship
      </label>

      <input
        type="text"
        name="reference1Relationship"
        value={formData.reference1Relationship}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Years Known
      </label>

      <input
        type="number"
        name="reference1YearsKnown"
        value={formData.reference1YearsKnown}
        onChange={handleChange}
      />

    </div>

    <div className="full-width">

      <label>
        Address
      </label>

      <input
        type="text"
        name="reference1Address"
        value={formData.reference1Address}
        onChange={handleChange}
      />

    </div>

  </div>

  {/* REFERENCE 2 */}

  <div className="wizard-section-title">

    Reference #2

  </div>

  <div className="wizard-form-grid">

    <div>

      <label>
        Full Name
      </label>

      <input
        type="text"
        name="reference2Name"
        value={formData.reference2Name}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Phone Number
      </label>

      <input
        type="text"
        name="reference2Phone"
        value={formData.reference2Phone}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Relationship
      </label>

      <input
        type="text"
        name="reference2Relationship"
        value={formData.reference2Relationship}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Years Known
      </label>

      <input
        type="number"
        name="reference2YearsKnown"
        value={formData.reference2YearsKnown}
        onChange={handleChange}
      />

    </div>

    <div className="full-width">

      <label>
        Address
      </label>

      <input
        type="text"
        name="reference2Address"
        value={formData.reference2Address}
        onChange={handleChange}
      />

    </div>

  </div>

  {/* GUARANTOR */}

  <div className="wizard-section-title">

    Guarantor Information

  </div>

  <div className="wizard-form-grid">

    <div>

      <label>
        Full Name
      </label>

      <input
        type="text"
        name="guarantorName"
        value={formData.guarantorName}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Phone Number
      </label>

      <input
        type="text"
        name="guarantorPhone"
        value={formData.guarantorPhone}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Occupation
      </label>

      <input
        type="text"
        name="guarantorOccupation"
        value={formData.guarantorOccupation}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Employer
      </label>

      <input
        type="text"
        name="guarantorEmployer"
        value={formData.guarantorEmployer}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Monthly Income
      </label>

      <input
        type="number"
        name="guarantorMonthlyIncome"
        value={formData.guarantorMonthlyIncome}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        ID Number
      </label>

      <input
        type="text"
        name="guarantorIdNumber"
        value={formData.guarantorIdNumber}
        onChange={handleChange}
      />

    </div>

    <div className="full-width">

      <label>
        Address
      </label>

      <input
        type="text"
        name="guarantorAddress"
        value={formData.guarantorAddress}
        onChange={handleChange}
      />

    </div>

  </div>

  <div className="wizard-actions">

    <button
      className="wizard-back-btn"
      onClick={previousStep}
    >
      Back
    </button>

    <button
      className="wizard-next-btn"
      onClick={nextStep}
    >
      Continue
    </button>

  </div>

</div>

)}


{currentStep === 5 && (

<div className="wizard-card">

  <div className="wizard-card-header">

    <h2>
      Application Details
    </h2>

    <p>
      Step 5 of 6
    </p>

  </div>

  {/* BUSINESS */}

{formData.loanType === "Business" && (

<div>

  <div className="wizard-section-title">
    Business Information
  </div>

  <div className="wizard-form-grid">

    <div>
      <label>Business Name</label>
      <input
        name="businessName"
        value={formData.businessName}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Registration Number</label>
      <input
        name="businessRegistrationNumber"
        value={formData.businessRegistrationNumber}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Business Phone</label>
      <input
        name="businessPhone"
        value={formData.businessPhone}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Business Email</label>
      <input
        name="businessEmail"
        value={formData.businessEmail}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Years In Operation</label>
      <input
        type="number"
        name="businessYearsOperation"
        value={formData.businessYearsOperation}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Number Of Employees</label>
      <input
        type="number"
        name="businessEmployees"
        value={formData.businessEmployees}
        onChange={handleChange}
      />
    </div>

    <div className="full-width">
      <label>Business Address</label>
      <input
        name="businessAddress"
        value={formData.businessAddress}
        onChange={handleChange}
      />
    </div>

    <div className="full-width">
      <label>Purpose Of Loan</label>
      <textarea
        rows="4"
        name="businessPurpose"
        value={formData.businessPurpose}
        onChange={handleChange}
      />
    </div>

    <div className="full-width">
      <label>Business Proposal</label>
      <textarea
        rows="5"
        name="businessProposal"
        value={formData.businessProposal}
        onChange={handleChange}
      />
    </div>

    <div className="full-width">
      <label>Business Plan Summary</label>
      <textarea
        rows="5"
        name="businessPlan"
        value={formData.businessPlan}
        onChange={handleChange}
      />
    </div>

  </div>

  <div className="wizard-section-title">
    Business Financial Information
  </div>

  <div className="wizard-form-grid">

    <div>
      <label>Monthly Sales</label>
      <input
        type="number"
        name="monthlySales"
        value={formData.monthlySales}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Monthly Expenses</label>
      <input
        type="number"
        name="monthlyExpensesBusiness"
        value={formData.monthlyExpensesBusiness}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Gross Profit</label>
      <input
        type="number"
        name="grossProfit"
        value={formData.grossProfit}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Net Profit</label>
      <input
        type="number"
        name="netProfit"
        value={formData.netProfit}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Projected Revenue</label>
      <input
        type="number"
        name="projectedRevenue"
        value={formData.projectedRevenue}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Projected Growth (%)</label>
      <input
        type="number"
        name="projectedGrowth"
        value={formData.projectedGrowth}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Break Even Period</label>
      <input
        name="breakEvenPeriod"
        value={formData.breakEvenPeriod}
        onChange={handleChange}
      />
    </div>

  </div>

  <div className="wizard-section-title">
    Market Analysis
  </div>

  <div className="wizard-form-grid">

    <div className="full-width">
      <label>Target Market</label>
      <textarea
        rows="4"
        name="targetMarket"
        value={formData.targetMarket}
        onChange={handleChange}
      />
    </div>

    <div className="full-width">
      <label>Competitors</label>
      <textarea
        rows="4"
        name="competitors"
        value={formData.competitors}
        onChange={handleChange}
      />
    </div>

    <div className="full-width">
      <label>Marketing Strategy</label>
      <textarea
        rows="5"
        name="marketingStrategy"
        value={formData.marketingStrategy}
        onChange={handleChange}
      />
    </div>

  </div>

</div>

)}

  {/* AGRICULTURE */}

  {formData.loanType === "Agriculture" && (

    <div>

      <div className="wizard-section-title">
        Agriculture Information
      </div>

      <div className="wizard-form-grid">

        <div>
          <label>Farm Name</label>
          <input
            name="farmName"
            value={formData.farmName}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Farm Location</label>
          <input
            name="farmLocation"
            value={formData.farmLocation}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Farm Size (Acres)</label>
          <input
            name="farmSize"
            value={formData.farmSize}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Land Ownership</label>

          <select
            name="landOwnership"
            value={formData.landOwnership}
            onChange={handleChange}
          >
            <option value="">
              Select
            </option>

            <option>
              Owned
            </option>

            <option>
              Leased
            </option>

            <option>
              Family Land
            </option>

          </select>

        </div>

        <div>
          <label>Type Of Agriculture</label>

          <select
            name="agricultureType"
            value={formData.agricultureType}
            onChange={handleChange}
          >
            <option value="">
              Select
            </option>

            <option>
              Rice
            </option>

            <option>
              Poultry
            </option>

            <option>
              Livestock
            </option>

            <option>
              Cash Crop
            </option>

            <option>
              Fishing
            </option>

          </select>

        </div>

        <div>
          <label>Years Experience</label>

          <input
            name="farmingExperience"
            value={formData.farmingExperience}
            onChange={handleChange}
          />
        </div>

        <div className="full-width">

          <label>
            Purpose Of Loan
          </label>

          <textarea
            rows="4"
            name="agriculturePurpose"
            value={formData.agriculturePurpose}
            onChange={handleChange}
          />

        </div>

      </div>

    </div>

  )}

  {/* VEHICLE */}

  {formData.loanType === "Vehicle" && (

    <div>

      <div className="wizard-section-title">
        Vehicle Information
      </div>

      <div className="wizard-form-grid">

        <div>
          <label>Vehicle Type</label>
          <input
            name="vehicleType"
            value={formData.vehicleType}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Make</label>
          <input
            name="vehicleMake"
            value={formData.vehicleMake}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Model</label>
          <input
            name="vehicleModel"
            value={formData.vehicleModel}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Year</label>
          <input
            name="vehicleYear"
            value={formData.vehicleYear}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Purchase Price</label>
          <input
            name="purchasePrice"
            value={formData.purchasePrice}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Seller Name</label>
          <input
            name="sellerName"
            value={formData.sellerName}
            onChange={handleChange}
          />
        </div>

      </div>

    </div>
)}


{formData.loanType === "Education" && (

<div>

  <div className="wizard-section-title">
    Education Information
  </div>

  <div className="wizard-form-grid">

    <div>
      <label>Institution Name</label>
      <input
        name="institutionName"
        value={formData.institutionName}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Country</label>
      <input
        name="country"
        value={formData.country}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Programme Name</label>
      <input
        name="programmeName"
        value={formData.programmeName}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Programme Duration</label>
      <input
        name="programmeDuration"
        value={formData.programmeDuration}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Tuition Cost</label>
      <input
        name="tuitionCost"
        value={formData.tuitionCost}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Accommodation Cost</label>
      <input
        name="accommodationCost"
        value={formData.accommodationCost}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Travel Cost</label>
      <input
        name="travelCost"
        value={formData.travelCost}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Books & Materials</label>
      <input
        name="booksCost"
        value={formData.booksCost}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Expected Graduation</label>
      <input
        type="date"
        name="graduationDate"
        value={formData.graduationDate}
        onChange={handleChange}
      />
    </div>

    <div>
      <label>Scholarship Amount</label>
      <input
        name="scholarshipAmount"
        value={formData.scholarshipAmount}
        onChange={handleChange}
      />
    </div>

  </div>

</div>

)}

{formData.loanType === "Home Improvement" && (

<div>

  <div className="wizard-section-title">
    Property Information
  </div>

  <div className="wizard-form-grid">

    <div className="full-width">

      <label>
        Property Address
      </label>

      <input
        name="propertyAddress"
        value={formData.propertyAddress}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Ownership Status
      </label>

      <select
        name="ownershipStatus"
        value={formData.ownershipStatus}
        onChange={handleChange}
      >

        <option value="">
          Select
        </option>

        <option>
          Owned
        </option>

        <option>
          Family Property
        </option>

        <option>
          Lease
        </option>

      </select>

    </div>

    <div>

      <label>
        Improvement Type
      </label>

      <input
        name="improvementType"
        value={formData.improvementType}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Contractor Name
      </label>

      <input
        name="contractorName"
        value={formData.contractorName}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Estimated Cost
      </label>

      <input
        name="estimatedProjectCost"
        value={formData.estimatedProjectCost}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Completion Date
      </label>

      <input
        type="date"
        name="completionDate"
        value={formData.completionDate}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Current Property Value
      </label>

      <input
        name="propertyValueBefore"
        value={formData.propertyValueBefore}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Estimated Value After
      </label>

      <input
        name="propertyValueAfter"
        value={formData.propertyValueAfter}
        onChange={handleChange}
      />

    </div>

  </div>

</div>

)}


{formData.loanType === "Personal" && (

<div>

  <div className="wizard-section-title">
    Personal Loan Details
  </div>

  <div className="wizard-form-grid">

    <div className="full-width">

      <label>
        Reason For Loan
      </label>

      <textarea
        rows="5"
        name="personalLoanReason"
        value={formData.personalLoanReason}
        onChange={handleChange}
      />

    </div>

    <div className="full-width">

      <label>
        Expected Benefit
      </label>

      <textarea
        rows="4"
        name="expectedBenefit"
        value={formData.expectedBenefit}
        onChange={handleChange}
      />

    </div>

    <div className="full-width">

      <label>
        Repayment Strategy
      </label>

      <textarea
        rows="4"
        name="repaymentStrategy"
        value={formData.repaymentStrategy}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Other Funding Sources
      </label>

      <input
        name="otherFundingSources"
        value={formData.otherFundingSources}
        onChange={handleChange}
      />

    </div>

    <div>

      <label>
        Disposable Monthly Income
      </label>

      <input
        name="disposableIncome"
        value={formData.disposableIncome}
        onChange={handleChange}
      />

    </div>

  </div>

</div>

)}



  <div className="wizard-actions">

    <button
      className="wizard-back-btn"
      onClick={previousStep}
    >
      Back
    </button>

    <button
      className="wizard-next-btn"
      onClick={nextStep}
    >
      Continue
    </button>

  </div>

</div>

)}


{currentStep === 6 && (

<div
  className="wizard-card review-card"
  ref={reviewRef}
>

  <div className="wizard-card-header">

    <h2>
      Review Application
    </h2>

    <p>
      Review all information before exporting.
    </p>

  </div>

  {/* PERSONAL */}

  <div className="review-section">

    <h3>
      Personal Information
    </h3>

    <div className="review-grid">

      <div>
        <strong>Name:</strong>
        {formData.fullName}
      </div>

      <div>
        <strong>Phone:</strong>
        {formData.phone}
      </div>

      <div>
        <strong>Email:</strong>
        {formData.email}
      </div>

      <div>
        <strong>Occupation:</strong>
        {formData.occupation}
      </div>

      <div>
        <strong>Employer:</strong>
        {formData.employer}
      </div>

      <div>
        <strong>Income:</strong>
        ${formData.monthlyIncome}
      </div>

    </div>

  </div>

  {/* LOAN */}

  <div className="review-section">

    <h3>
      Loan Information
    </h3>

    <div className="review-grid">

      <div>
        <strong>Loan Type:</strong>
        {formData.loanType}
      </div>

      <div>
        <strong>Amount:</strong>
        ${formData.loanAmount}
      </div>

      <div>
        <strong>Period:</strong>
        {formData.repaymentPeriod}
      </div>

      <div>
        <strong>Interest:</strong>
        {formData.interestRate}%
      </div>

    </div>

    <div className="review-long-text">

      <strong>
        Purpose:
      </strong>

      <p>
        {formData.loanPurpose}
      </p>

    </div>

  </div>

  {/* FINANCIAL */}

  <div className="review-section">

    <h3>
      Financial Information
    </h3>

    <div className="review-grid">

      <div>
        <strong>Bank:</strong>
        {formData.bankName}
      </div>

      <div>
        <strong>Savings:</strong>
        ${formData.savingsAmount}
      </div>

      <div>
        <strong>Expenses:</strong>
        ${formData.monthlyExpenses}
      </div>

      <div>
        <strong>Debt:</strong>
        ${formData.existingDebt}
      </div>

    </div>

  </div>

  {/* REFERENCES */}

  <div className="review-section">

    <h3>
      References
    </h3>

    <div className="review-grid">

      <div>
        <strong>
          Ref #1:
        </strong>

        {formData.reference1Name}

      </div>

      <div>
        <strong>
          Ref #2:
        </strong>

        {formData.reference2Name}

      </div>

      <div>
        <strong>
          Guarantor:
        </strong>

        {formData.guarantorName}

      </div>

    </div>

  </div>


  {formData.loanType === "Business" && (

<div className="review-section">

  <h3>
    Business Information
  </h3>

  <div className="review-grid">

    <div>
      <strong>Name:</strong>
      {formData.businessName}
    </div>

    <div>
      <strong>Employees:</strong>
      {formData.businessEmployees}
    </div>

    <div>
      <strong>Monthly Sales:</strong>
      ${formData.monthlySales}
    </div>

    <div>
      <strong>Net Profit:</strong>
      ${formData.netProfit}
    </div>

  </div>

</div>

)}

{formData.loanType === "Agriculture" && (

<div className="review-section">

  <h3>
    Agriculture Information
  </h3>

  <div className="review-grid">

    <div>
      <strong>
        Farm:
      </strong>

      {formData.farmName}

    </div>

    <div>
      <strong>
        Type:
      </strong>

      {formData.agricultureType}

    </div>

    <div>
      <strong>
        Acres:
      </strong>

      {formData.farmSize}

    </div>

    <div>
      <strong>
        Ownership:
      </strong>

      {formData.landOwnership}

    </div>

  </div>

</div>

)}


{formData.loanType === "Vehicle" && (

<div className="review-section">

  <h3>
    Vehicle Information
  </h3>

  <div className="review-grid">

    <div>
      <strong>Make:</strong>
      {formData.vehicleMake}
    </div>

    <div>
      <strong>Model:</strong>
      {formData.vehicleModel}
    </div>

    <div>
      <strong>Year:</strong>
      {formData.vehicleYear}
    </div>

    <div>
      <strong>Price:</strong>
      ${formData.purchasePrice}
    </div>

  </div>

</div>

)}

<div className="signature-section">

  <div className="signature-box">

    ______________________

    <span>
      Applicant Signature
    </span>

  </div>

  <div className="signature-box">

    ______________________

    <span>
      Loan Officer
    </span>

  </div>

</div>

<div className="wizard-actions">

  <button
    className="wizard-back-btn"
    onClick={previousStep}
  >
    Back
  </button>

  <button
    className="wizard-next-btn"
    onClick={() =>
      window.print()
    }
  >
    Print Application
  </button>

<button
  className="wizard-next-btn"
  onClick={generatePdf}
>
  Export PDF
</button>

</div>
</div>
)}

    </div>

  );

}